<template>
  <div>
    <v-card-text class="slide_wrapper_item">
      <span></span>
      <div class="slide_wrapper_item_cap">
        <span class="reds">Плохо</span>
        <span class="greens">Хорошо</span>
      </div>
    </v-card-text>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "SliderWrapper",
};
</script>
<style lang="sass">
.slide_wrapper_item
  display: flex
  flex-wrap: wrap
  span
    width: 250px
  div.slide_wrapper_item_cap
    display: flex
    justify-content: space-between
    width: 150px
    span
      text-align: center

.reds
  color: red
.greens
  color: green
</style>
